if (!customElements.get('sticky-header')) {
customElements.define('sticky-header', class StickyHeader extends HTMLElement {
constructor() {
super();
}
connectedCallback() {
this.header = document.getElementById(this.dataset.stickyElementId) ? document.getElementById(this.dataset.stickyElementId) : this.parentNode;
this.siteHeader = document.getElementById('site-header');
this.headerBounds = {};
this.currentScrollTop = 0;
this.firstSectionInMain = document.getElementById('MainContent').firstElementChild;
this.offsetPosition = this.siteHeader.offsetHeight + this.firstSectionInMain.offsetHeight;
this.onScrollHandler = this.onScroll.bind(this);
window.addEventListener('scroll', this.onScrollHandler, false);
this.createObserver();
}
disconnectedCallback() {
window.removeEventListener('scroll', this.onScrollHandler);
}
createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});
observer.observe(this.header);
}
onScroll() {
const scrollTop = window.scrollY || document.documentElement.scrollTop;
if (scrollTop > this.currentScrollTop && scrollTop > this.offsetPosition) {
requestAnimationFrame(this.scrolledPast.bind(this));
} else if (scrollTop < this.currentScrollTop && scrollTop > this.offsetPosition) {
requestAnimationFrame(this.scrollingUp.bind(this));
} else if (scrollTop <= 0) {
requestAnimationFrame(this.reset.bind(this));
}
this.currentScrollTop = scrollTop;
}
scrolledPast() {
this.header.classList.add('scrolled-past', 'sticky', 'motion-reduce');
this.closeMenuDisclosure();
this.closeSearchModal();
if (this.dataset.transparentHeader) return;
document.getElementById('MainContent').style.paddingTop = `${this.siteHeader.offsetHeight}px`;
}
scrollingUp() {
this.header.classList.add('sticky', 'scrolling-up', 'motion-reduce');
this.header.classList.remove('scrolled-past');
}
reset() {
this.header.classList.remove('scrolled-past', 'sticky', 'scrolling-up');
if (this.dataset.transparentHeader) return;
document.getElementById('MainContent').style.paddingTop = '0';
}
closeMenuDisclosure() {
this.disclosures = this.disclosures || this.siteHeader.querySelectorAll('details-disclosure');
this.disclosures.forEach(disclosure => disclosure.close());
}
closeSearchModal() {
this.searchModal = this.searchModal || this.siteHeader.querySelector('details-modal');
this.searchModal.close(false);
}
});
}